import axios from 'axios'

export async function getCustomersBillingDataQuery(searchStr) {
    return axios
        .get(`${process.env.API_URL}/billing/all`, {
            params: {
                search: searchStr
            }
        })
        .then(response => response.data)
}
